import React from 'react';
import { useInView } from '../../hooks';
import { PlatformIcon } from '../common/Icons';
import { platformsData } from '../../data/platforms';

const PlatformsSection = () => {
  const [ref, isInView] = useInView(0.1);

  return (
    <section
      id="platforms"
      className="py-24 bg-gradient-to-b from-transparent via-primary-500/5 to-transparent"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="section-subtitle text-primary-500">MULTI-PLATFORM</p>
          <h2 className="section-title">
            PLAY <span className="text-gradient">ANYWHERE</span>
          </h2>
          <p className="section-description">
            From mobile to console, VR to browser — experience African adventures
            on your favorite platform
          </p>
        </div>

        <div
          ref={ref}
          className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 transition-all duration-1000 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {platformsData.map((platform, i) => (
            <div
              key={platform.id}
              className="card-hover p-6 bg-white/5 rounded-2xl border border-white/10 text-center group cursor-pointer"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-xl bg-gradient-to-br from-primary-500/20 to-secondary-400/20 flex items-center justify-center text-gray-400 group-hover:text-primary-500 transition-colors">
                <PlatformIcon platform={platform.id} />
              </div>
              <h3 className="font-bold text-lg mb-2">{platform.name}</h3>
              <p className="text-gray-500 text-sm">{platform.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformsSection;
